import { userVar } from "lib/user";

export enum ProductPriceType {
  MemberPrice = "Member Price",
  TypicalPrice = "Typical Price"
}

export const getSegmentPurchaseType = (): ProductPriceType => {
  const user = userVar();

  if (user?.isMember) return ProductPriceType.MemberPrice;
  if (user?.hasMembershipInBag) return ProductPriceType.MemberPrice;

  return ProductPriceType.TypicalPrice;
};
